import { useDispatch } from 'react-redux';

import { MOVABLE_INK_INTEGRATIONS_CREATE_URL } from 'api/MovableInkIntegrationsAPI';
import { addNegativeToast, addPositiveToast } from 'modules/toastContainer';
import { ApiMethod } from 'services/api';
import { useRestMutation } from 'utils/hooks/api/useRestMutation';

import { useTranslations } from '../hooks/useTranslations';
import { NoOp } from 'utils/noop';

type MovableInkIntegrationRequest = {
  code: string;
  name: string;
  account_id: string;
};

export const useAddIntegration = (successCb?: NoOp) => {
  const { t } = useTranslations();
  const dispatch = useDispatch();
  const { mutate, isLoading } = useRestMutation<unknown, MovableInkIntegrationRequest>(
    MOVABLE_INK_INTEGRATIONS_CREATE_URL,
    ApiMethod.post,
    {
      onSuccess() {
        dispatch(addPositiveToast(t('toast.addSuccess')));
        successCb?.();
      },
      onError() {
        dispatch(addNegativeToast(t('toast.addError')));
      },
    },
  );
  const addIntegration = (code: string, name: string, login: string) =>
    mutate({ code, name, account_id: login });

  return {
    addIntegration,
    isLoading,
  };
};
